import script from "./HomeStats.vue?vue&type=script&setup=true&lang=js"
export * from "./HomeStats.vue?vue&type=script&setup=true&lang=js"

import "./HomeStats.vue?vue&type=style&index=0&id=17025d35&lang=scss&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-17025d35"]])

export default __exports__